import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

export const TEL1_MAX_LENGTH = 3;
export const TEL2_MAX_LENGTH = 4;
export const TEL3_MAX_LENGTH = 4;

const uniqueDateCheck: yup.TestFunction<string | undefined, {}> = (
  value,
  context,
) => {
  const { datetime1, datetime2, datetime3 } = context.parent;
  switch (context.path) {
    case 'preferredDatetimes.datetime1': {
      if (value === datetime2 || value === datetime3) return !value;
      return true;
    }
    case 'preferredDatetimes.datetime2': {
      if (value === datetime1 || value === datetime3) return !value;
      return true;
    }
    case 'preferredDatetimes.datetime3': {
      if (value === datetime1 || value === datetime2) return !value;
      return true;
    }
  }
  return false;
};

const validationSchema = yup.object().shape({
  preferredDatetimes: yup.object().shape({
    datetime1: yup.string().required().test(uniqueDateCheck),
    datetime2: yup.string().required().test(uniqueDateCheck),
    datetime3: yup.string().required().test(uniqueDateCheck),
  }),
  reservationHolder: yup
    .object()
    .shape({
      familyName: yup.string().required(),
      firstName: yup.string().required(),
      familyNameKana: yup
        .string()
        .required('フリガナは必須です')
        .matches(/^([ァ-ン]|ー)+$/, {
          message: '全角カタカナで入力してください',
        }),
      firstNameKana: yup
        .string()
        .required('フリガナは必須です')
        .matches(/^([ァ-ン]|ー)+$/, {
          message: '全角カタカナで入力してください',
        }),
      tel1: yup.string().required(),
      tel2: yup.string().required(),
      tel3: yup.string().required(),
    })
    .test('phoneNo', ({ tel1, tel2, tel3 }) => {
      const fixedRegex =
        /^0(\d-\d{4}|\d{2}-\d{3}|\d{3}-\d{2}|\d{4}-\d)-\d{4}$/;
      const mobileRegex = /^(050|070|080|090)-\d{4}-\d{4}$/;
      if (fixedRegex.test(`${tel1}-${tel2}-${tel3}`)) return true;
      if (mobileRegex.test(`${tel1}-${tel2}-${tel3}`)) return true;
      return false;
    }),
  mUnitId: yup.number().required(),
  unitMemo: yup.string(),
});

export interface CoatingStep2FormData {
  preferredDatetimes: {
    datetime1?: string;
    datetime2?: string;
    datetime3?: string;
  };
  reservationHolder: {
    familyName?: string;
    firstName?: string;
    familyNameKana?: string;
    firstNameKana?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
  };
  mUnitId?: number;
  unitMemo: string;
}

export const useCoatingStep2 = (initialState: CoatingStep2FormData) => {
  const formMethods = useForm<CoatingStep2FormData>({
    defaultValues: initialState,
    resolver: yupResolver(validationSchema) as any,
    mode: 'onChange',
  });

  return {
    formMethods,
  };
};
